import { apiHelper } from "@/utils";
import { API } from "@/constants";
import qs from "qs";
const API_URL = `${API.BASE_URL_API}/v1`;

export function eventFormData(data, updating = false) {
  const body = new FormData();
  if (updating) body.append("_method", "PUT");
  [
    "company_uuid",
    "name",
    "description",
    "venue_type",
    "venue_display_name",
    "venue_link",
    "link",
    "started_at",
    "ended_at",
    "registration_closed_at",
    "capacity",
    "pic_user_uuid",
  ].forEach((key) => body.append(key, data[key] ?? ""));
  body.append(
    "is_registration_enabled",
    [true, 1, "1"].includes(data.is_registration_enabled) ? 1 : 0,
  );
  (data.keywords || []).forEach((keyword, index) =>
    body.append(`keywords[${index}]`, keyword),
  );
  if (data.cover_image instanceof File)
    body.append("cover_image", data.cover_image);
  return body;
}
export const eventService = {
  getUsers(uuid, filter = {}) {
    const params = {
      page: filter.pageNumber || 1,
      size: filter.pageSize || 15,
      sortBy: filter.sortBy || "created_at",
      orderBy: filter.orderBy === "asc" ? "asc" : "desc",
    };
    if (filter.status !== "" && filter.status != null)
      params.status = filter.status;
    if (filter.searchArray?.length) params.search_words = filter.searchArray;
    return apiHelper(API_URL).get(`/events/${encodeURIComponent(uuid)}/users`, {
      params,
      paramsSerializer: (query) =>
        qs.stringify(query, {
          arrayFormat: "brackets",
          encodeValuesOnly: true,
        }),
    });
  },
  getAll(filter = {}) {
    const params = {
      page: filter.pageNumber || 1,
      size: filter.pageSize || 15,
    };
    if (filter.searchArray?.length) params.search_words = filter.searchArray;
    return apiHelper(API_URL).get("/events", { params });
  },
  show(uuid) {
    return apiHelper(API_URL).get(`/events/${encodeURIComponent(uuid)}`);
  },
  store(data) {
    return apiHelper(API_URL).post("/events", eventFormData(data));
  },
  update(data) {
    return apiHelper(API_URL).post(
      `/events/${encodeURIComponent(data.uuid)}`,
      eventFormData(data, true),
    );
  },
  updateActiveStatus(uuid, active) {
    return apiHelper(API_URL).patch(`/events/${encodeURIComponent(uuid)}`, {
      is_active: [true, 1, "1"].includes(active) ? 1 : 0,
    });
  },
  softDelete(uuid) {
    return apiHelper(API_URL).patch(
      `/events/delete/${encodeURIComponent(uuid)}`,
    );
  },
};
